module.exports = __webpack_public_path__ + "img/peration-bg.cf213b36.png";